import { render, staticRenderFns } from "./index-no-template.vue?vue&type=template&id=22c9649e&"
import script from "./index-no-template.vue?vue&type=script&lang=js&"
export * from "./index-no-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports